import useTokenKeycloak from 'useTokenKeycloack';
import handleFetchErrors from './handleFetchErrors';

const fetchWithToken = async (url, options = {}, fetchAccessToken) => {
  
  console.log("fetchWithToken called with URL:", url);

  let token = sessionStorage.getItem('token'); 

  if (!token) {
    console.log("Token not found in sessionStorage, fetching new token...");
    token = await fetchAccessToken();
    sessionStorage.setItem('token', token); 
  } else {
    console.log("Token found in sessionStorage:", token);
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers
      //,'Authorization': `Bearer ${token}`
    },
  });

  // Chama a função de tratamento de erro
  return handleFetchErrors(response, fetchAccessToken);
};

// Hook customizado para usar fetchWithToken
export const useFetchWithToken = () => {
  const { fetchAccessToken } = useTokenKeycloak();

  const fetchWithAuthToken = (url, options = {}) => {
    return fetchWithToken(url, options, fetchAccessToken);
  };

  return { fetchWithAuthToken };
};

export default fetchWithToken;
